
const ParkingSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-blue-50/50 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            駐車場のご案内
          </h2>
          
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="flex items-center mb-3">
                <i className="ri-parking-box-line text-3xl text-[#007bbb] mr-3"></i>
                <h3 className="text-xl font-semibold text-gray-900">駐車台数</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                普通車10台分の駐車スペースをご用意しております。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="flex items-center mb-3">
                <i className="ri-time-line text-3xl text-[#007bbb] mr-3"></i>
                <h3 className="text-xl font-semibold text-gray-900">利用時間</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                診療時間内は無料でご利用いただけます。
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="flex items-center mb-3">
                <i className="ri-information-line text-3xl text-[#007bbb] mr-3"></i>
                <h3 className="text-xl font-semibold text-gray-900">ご注意</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                満車の場合は、近隣のコインパーキングをご利用ください。クリニック前の道路への駐車はご遠慮ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParkingSection;
